import React, { useState } from "react";
import NavBar from "../general/navBar";

const Filter = () => {
  const [showMoreRegions, setShowMoreRegions] = useState(false);
  const [showMoreCategories, setShowMoreCategories] = useState(false);
  return (
    <aside
      className="offer-filters-container"
      aria-label="Filtres de recherche d'emploi"
    >
      <h2 className="offer-filters-title">Filtres</h2>

      {/* Poste */}
      <section
        className="offer-filters-section"
        aria-labelledby="offer-filters-poste"
      >
        <h3 id="offer-filters-poste" className="offer-filters-subtitle">
          <i className="fa fa-briefcase"></i> Poste
        </h3>
        <div className="offer-filters-search-wrapper">
          <i
            className="fa fa-search offer-filters-search-icon"
            aria-hidden="true"
          />
          <input
            type="search"
            placeholder="Rechercher…"
            aria-label="Rechercher un poste"
            className="offer-filters-search"
          />
        </div>
      </section>

      {/* Région */}
      <section
        className="offer-filters-section"
        aria-labelledby="offer-filters-region"
      >
        <h3 id="offer-filters-region" className="offer-filters-subtitle">
          <i className="fa fa-map"></i> Région
        </h3>
        <ul className="offer-filters-list">
          {/* Filtres visibles */}
          <li>
            <label className="offer-filters-label">
              <span className="offer-filters-checkbox-label">
                <input type="checkbox" />
                <span className="offer-filters-label-text">
                  Pays de la Loire
                </span>
              </span>
              <span className="offer-filters-label-count">24</span>
            </label>
          </li>
          <li>
            <label className="offer-filters-label">
              <span className="offer-filters-checkbox-label">
                <input type="checkbox" />
                <span className="offer-filters-label-text">Île-de-France</span>
              </span>
              <span className="offer-filters-label-count">24</span>
            </label>
          </li>
          <li>
            <label className="offer-filters-label">
              <span className="offer-filters-checkbox-label">
                <input type="checkbox" />
                <span className="offer-filters-label-text">
                  Provence-Alpes-Côte-d'Azur
                </span>
              </span>
              <span className="offer-filters-label-count">24</span>
            </label>
          </li>

          {/* Filtres supplémentaires */}
          <div
            className={`offer-filters-collapse ${
              showMoreRegions ? "open" : ""
            }`}
          >
            <li>
              <label className="offer-filters-label">
                <span className="offer-filters-checkbox-label">
                  <input type="checkbox" />
                  <span className="offer-filters-label-text">Occitanie</span>
                </span>
                <span className="offer-filters-label-count">12</span>
              </label>
            </li>
            <li>
              <label className="offer-filters-label">
                <span className="offer-filters-checkbox-label">
                  <input type="checkbox" />
                  <span className="offer-filters-label-text">
                    Nouvelle-Aquitaine
                  </span>
                </span>
                <span className="offer-filters-label-count">18</span>
              </label>
            </li>
          </div>
        </ul>
        <button
          type="button"
          className="offer-filters-button"
          onClick={() => setShowMoreRegions(!showMoreRegions)}
        >
          {showMoreRegions
            ? "Voir moins de localisations"
            : "Voir plus de localisations"}
          <i
            className={`fa-solid ${
              showMoreRegions ? "fa-chevron-up" : "fa-chevron-down"
            }`}
          />
        </button>
      </section>

      {/* Catégorie */}
      <section
        className="offer-filters-section"
        aria-labelledby="offer-filters-categorie"
      >
        <h3 id="offer-filters-categorie" className="offer-filters-subtitle">
          <i className="fa fa-cog"></i> Catégorie
        </h3>
        <ul className="offer-filters-list">
          {/* Filtres visibles */}
          <li>
            <label className="offer-filters-label">
              <span className="offer-filters-checkbox-label">
                <input type="checkbox" />
                <span className="offer-filters-label-text">Restauration</span>
              </span>
              <span className="offer-filters-label-count">24</span>
            </label>
          </li>
          <li>
            <label className="offer-filters-label">
              <span className="offer-filters-checkbox-label">
                <input type="checkbox" />
                <span className="offer-filters-label-text">
                  Transport & Logistique
                </span>
              </span>
              <span className="offer-filters-label-count">24</span>
            </label>
          </li>
          <li>
            <label className="offer-filters-label">
              <span className="offer-filters-checkbox-label">
                <input type="checkbox" />
                <span className="offer-filters-label-text">Distribution</span>
              </span>
              <span className="offer-filters-label-count">24</span>
            </label>
          </li>
          <div
            className={`offer-filters-collapse ${
              showMoreCategories ? "open" : ""
            }`}
          >
            <li>
              <label className="offer-filters-label">
                <span className="offer-filters-checkbox-label">
                  <input type="checkbox" />
                  <span className="offer-filters-label-text">Informatique</span>
                </span>
                <span className="offer-filters-label-count">8</span>
              </label>
            </li>
            <li>
              <label className="offer-filters-label">
                <span className="offer-filters-checkbox-label">
                  <input type="checkbox" />
                  <span className="offer-filters-label-text">Bâtiment</span>
                </span>
                <span className="offer-filters-label-count">11</span>
              </label>
            </li>
          </div>
        </ul>
        <button
          type="button"
          className="offer-filters-button"
          onClick={() => setShowMoreCategories(!showMoreCategories)}
        >
          {showMoreCategories
            ? "Voir moins de catégorie"
            : "Voir plus de catégorie"}
          <i
            className={`fa-solid ${
              showMoreCategories ? "fa-chevron-up" : "fa-chevron-down"
            }`}
          />
        </button>
      </section>
    </aside>
  );
};

export default Filter;
